<template>
    <div class="wapper">
        <div class="query-wapper">
            <el-row :gutter="20">
                <el-col :span="8">
                    <el-input placeholder="请输入方案编号" v-model="query.commissionCode"></el-input>
                </el-col>
                <el-col :span="8">
                    <el-input placeholder="请输入方案名称关键字" v-model="query.commissionName"></el-input>
                </el-col>
                <el-col :span="8">
                    <el-select placeholder="请选择集采类型" v-model="query.jcCategory" style="width:100%;">
                        <el-option v-for="item in categoryList" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="8">
                    <el-input placeholder="请输入创建人姓名" v-model="query.creatorName"></el-input>
                </el-col>
                <el-col :span="8">
                    <el-select placeholder="请选择方案状态" v-model="query.state" style="width:100%;">
                        <el-option v-for="item in stateList" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-col>
            </el-row>
            <div class="button-wapper">
                <el-button plain @click="getInfoList(undefined)">查询</el-button>
                <el-button plain @click="reset">重置</el-button>
                <el-button plain @click="add" type="primary" v-auth="'edit'">新增</el-button>
            </div>
        </div>
        <div class="content-wapper">
            <el-table :data="infos" size='mini' empty-text :border="true">
                <el-table-column prop="commissionCode" label="方案编号"></el-table-column>
                <el-table-column prop="commissionName" label="方案名称"></el-table-column>
                <el-table-column prop="jcCategoryName" label="集采类型"></el-table-column>
                <el-table-column prop="sumCommission" label="总提成值（%）"></el-table-column>
                <el-table-column prop="creatorName" label="创建人"></el-table-column>
                <el-table-column label="状态">
                    <template slot-scope="scope">
                        <el-switch v-auth="'edit'" v-model="scope.row.state" @change="planStateUpdate(scope.row)"
                            :active-value="1" :inactive-value="0" active-color="#13ce66" inactive-color="#ff4949">
                        </el-switch>
                        <span v-auth-reverse="'edit'">
                            {{ scope.row.state }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="gmtCreate" label="创建时间"></el-table-column>
                <el-table-column label="操作" fixed="right" width="170">
                    <template slot-scope="scope">
                        <el-button @click="edit(scope.row)" type="text" size="small" v-auth="'edit'">编辑</el-button>
                        <el-button @click="getDetail(scope.row)" type="text" size="small">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <br>
            <el-pagination :current-page.sync="query.pageIndex" :page-size="query.pageSize"
                @current-change="handleCurrentChange" class="pagation" layout="prev, pager, next, jumper"
                :total="query.total">
            </el-pagination>
        </div>
        <!-- 添加合约公司 -->
        <addInvoiceCompany ref="addInvoiceCompany" @refresh="getInfoList"></addInvoiceCompany>
    </div>
</template>

<script>
import _purchasePlan from '@/service/purchase-plan-service'
import addInvoiceCompany from '@/views/invoice/company/add-invoice-company'

export default {
    components: {
        addInvoiceCompany
    },
    data() {
        return {
            infos: null,
            categoryList: [], // 集采类型
            stateList: [
                {
                    id: 0,
                    name: '已关闭'
                },
                {
                    id: 1,
                    name: '已开启'
                }
            ],
            query: {
                commissionCode: null,
                jcCategory: null,
                commissionName: null,
                creatorName: null,
                state: null,
                pageIndex: 1,
                pageSize: 20,
                total: 0
            }
        }
    },
    mounted() {
        var params = this.$getParams()
        this.getcategoryList();
        if (params != null) {
            this.query = params
            this.getInfoList(this.query.pageIndex)
        } else {
            this.getInfoList()
        }
    },
    methods: {
        // 获取表格列表 
        getInfoList(pageIndex) {
            const obj = {}
            if(this.query.commissionCode){
                obj.commissionCode = this.query.commissionCode
            }
            if(this.query.jcCategory){
                obj.jcCategory = this.query.jcCategory
            }
            if(this.query.commissionName){
                obj.commissionName = this.query.commissionName
            }
            if(this.query.creatorName){
                obj.creatorName = this.query.creatorName
            }
            if(this.query.state !== null){
                obj.state = this.query.state
            }
            if (pageIndex)
                this.query.pageIndex = pageIndex
            else
                this.query.pageIndex = 1
            _purchasePlan.queryPlanList(
                obj,
                (response) => {
                    // 请求成功
                    this.infos = response
                    this.query.total = response.length
                })
        },
        // 集采类型下拉列表
        getcategoryList() {
            _purchasePlan.getcategoryList({ state: 'JcCategoryEnum' }, (res) => {
                this.categoryList = res;
            })
        },
        // 分页 
        handleCurrentChange(pageIndex) {
            this.getInfoList(pageIndex)
        },
        // 新增按钮 
        add() {
            this.$router.push({
                path: '/add-purchase-plan'
            })
        },
        // 查看按钮 
        getDetail(row) {
            this.$saveParams(this.query)
            this.$router.push({
                path: '/purchase-plan-detail?id=' + row.id
            })
        },
        // 编辑按钮 
        edit(row) {
            console.log(row);
            this.$saveParams(this.query)
            this.$router.push({
                path: '/add-purchase-plan?id=' + row.id + "&type=edit"
            })
        },
        // 重置搜索表单 
        reset() {
            this.query = {
                commissionCode: null,
                jcCategory: null,
                commissionName: null,
                creatorName: null,
                state: null,
                pageIndex: 1,
                pageSize: 20,
                total: 0
            }
            this.getInfoList()
        },
        // 更改状态 
        planStateUpdate(row) {
            console.log(row);
            if (row.state === 0) {
                this.$confirm('关闭该提成方案后，销售下单过程中将不可选择此方案，确定要关闭吗?', '提醒', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    _purchasePlan.planStateUpdate(row.id, row.state, () => {
                        this.$message({
                            type: 'success',
                            message: '关闭成功!'
                        });
                        this.getInfoList()
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消修改'
                    });
                    this.getInfoList()
                });
            } else if (row.state === 1) {
                this.$confirm('开启该提成方案后，销售下单过程中将可以选择此方案，确定要开启吗?', '提醒', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    _purchasePlan.planStateUpdate(row.id, row.state, () => {
                        this.$message({
                            type: 'success',
                            message: '开启成功!'
                        });
                        this.getInfoList()
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消修改'
                    });
                    this.getInfoList()
                });
            }
        }
    }
}
</script>

<style scoped>
.wapper {
    padding: 15px;
}

.header {
    margin-bottom: 15px;
}

.query-wapper {
    margin: 15px;
    padding: 15px;
    border: 1px solid #d6dbe5;
    position: relative;
    background: #fff;
}

.query-wapper::after {
    position: absolute;
    content: '筛选条件';
    top: -9px;
    color: #909399;
    background-color: #fbfbfb;
}

.content-wapper {
    padding: 0 15px;
    padding-bottom: 30px;
}

.button-wapper {
    margin-top: 10px;
}

.el-row {
    margin-bottom: 15px;
}
</style>